import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { useCreateTicket } from '../../Hooks/Features/HelpDesk/useCreateTicket';
import CommonImage from '../CommonCompo/CommonImage/CommonImage';
import _ from 'underscore';
import { calculateWordsFromString } from '../../utils/Helper';
import { useCommon } from '../../Hooks/Common/useCommon';

const CreateTicket = ({ visible, onHide, options, selectedData, getRequestData, filters }) => {
    const { getValuePermission } = useCommon();
    const { handleOnChange, formValue, setFormValue, handleCreateTicket, subType, saveStatus, setSubType, setPrevData, statusOpts, userInfo, requestTypeColumns, dynamicInputHandle, requestTypeColumnValues, approverList, dynamicField, handleDropdownChange, handleCloseModal, layoutConfig, loader } = useCreateTicket({ options, selectedData, getRequestData, onHide });
    const isUserAuthorized = formValue?.createdBy && formValue?.createdBy !== userInfo?.user_code;
    const isTicketEditable = selectedData?.ticket_id && (selectedData?.is_status || selectedData?.created_by === userInfo?.user_code);

    const issuesTemplate = (option) => {
        return (
            <div className="d-flex gap-2 align-items-center">
                <span style={{ fontWeight: "bold" }}>{option.priority_name}</span>
                <span title={option.priority_descr} >
                    ({option.priority_descr.length > 90 ? `${option.priority_descr.slice(0, 90)}...` : option.priority_descr})
                </span>
            </div>
        )
    }

    const selectedIssuesTemplate = (option, props) => {
        if (option) {
            return (
                <div className="d-flex gap-2 align-items-center">

                    <span
                        className="rounded-pill d-flex justify-content-center px-2 py-1" style={{ background: "#d8d5d5" }}>
                        {option.priority_name}
                    </span>
                    <span> {option.priority_descr.length > 90 ? `${option.priority_descr.slice(0, 90)}...` : option.priority_descr}</span>
                </div>
            );
        }
        return <div>{props.placeholder}</div>
    }
    return (
        <div>
            <Dialog
                header={selectedData?.ticket_id ? "Update Ticket" : "Create New Ticket"}
                draggable={false}
                visible={visible}
                className='modal-medium'
                modal
                onHide={handleCloseModal}
            >
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className="row" style={{ rowGap: '0.2rem' }}>
                        {!getValuePermission("helpdesk_request_by_dropdown") && <div className="col-12 mb-1">
                            <label className="form-label">Request By</label>
                            <Dropdown
                                name="requested_user_code"
                                options={filters?.location?.location ? _.filter(options?.users, user => user?.location_name === filters?.location?.location) : options?.users}
                                value={formValue?.requested_user_code || null}
                                onChange={handleOnChange}
                                className="sk-input-dd w-100"
                                optionLabel="user_display_name"
                                optionValue="user_code"
                                filter
                                filterInputAutoFocus
                                disabled={selectedData?.ticket_id}
                            />
                        </div>}
                        <div className={layoutConfig.rootClass}>
                            <label className="form-label">Request Type *</label>
                            <Dropdown
                                name="requestType_root"
                                options={options?.requestType}
                                value={dynamicField[0] || null}
                                onChange={(e) => handleDropdownChange(e.value, 0)}
                                placeholder="Select Request Type"
                                className="sk-input-dd w-100"
                                optionLabel="request_type_name"
                                disabled={isUserAuthorized}
                            />
                        </div>
                        {dynamicField.map((currentSelection, index) => {
                            const currentId = currentSelection?.request_type_id;
                            if (!currentId) return null;

                            const childCategories = _.filter(options?.allType, { parent_request_type_id: currentId });
                            if (childCategories.length === 0) return null;

                            const nextIndex = index + 1;
                            const isLastElement = layoutConfig.activeNestedIds.indexOf(currentId) === (layoutConfig.activeNestedIds.length - 1);
                            const dynamicClass = isLastElement && layoutConfig.isOddCount ? "col-6 mb-1" : "col-md-6 col-12 mb-1";

                            return (
                                <div className={dynamicClass} key={`${currentId}_nested_${nextIndex}`}>
                                    <label className="form-label">{currentSelection.request_type_name} Category *</label>
                                    <Dropdown
                                        name={`dynamic_dropdown_level_${nextIndex}`}
                                        options={childCategories}
                                        value={dynamicField[nextIndex] || null}
                                        onChange={(e) => handleDropdownChange(e.value, nextIndex)}
                                        placeholder="Select Sub-Category"
                                        optionLabel="request_type_name"
                                        className="sk-input-dd w-100"
                                        disabled={isUserAuthorized}
                                    />
                                </div>
                            );
                        })}
                        <div className={layoutConfig.subTypeClass}>
                            <label className="form-label">Sub Request Type *</label>
                            <Dropdown
                                name="subType"
                                options={subType}
                                value={formValue?.subType || null}
                                onChange={(e) => handleOnChange({ target: { name: "subType", value: e.value } })}
                                disabled={!subType?.length || isUserAuthorized}
                                placeholder="Select Sub Request Type"
                                className="sk-input-dd w-100"
                                optionLabel="request_sub_type_name"
                            />
                        </div>
                        <div className="col-12 mb-1">
                            <label className="form-label">Subject *</label>
                            <input
                                type="text"
                                name="subject"
                                className="input-text w100"
                                value={formValue?.subject || ''}
                                onChange={handleOnChange}
                                disabled={isUserAuthorized}
                            />
                        </div>
                        <div className="col-12 mb-1">
                            <label className="form-label">Priority *</label>
                            <Dropdown
                                name="priority"
                                options={options?.priorityOption}
                                value={formValue?.priority || null}
                                onChange={handleOnChange}
                                className="sk-input-dd w-100"
                                optionLabel="priority_name"
                                filter
                                filterInputAutoFocus
                                itemTemplate={issuesTemplate}
                                valueTemplate={selectedIssuesTemplate}
                                disabled={isUserAuthorized}
                            />
                            {/* {formValue?.priority?.priority_descr && (
                                <p className='px-1 text-muted mt-1' style={{ fontSize: "12px" }}>
                                    {formValue.priority.priority_descr}
                                </p>
                            )} */}
                        </div>
                        {requestTypeColumns?.length > 0 && requestTypeColumns.map((val, index) => {
                            const value = _.find(requestTypeColumnValues, { request_type_column_id: val?.request_type_column_id });
                            const fileUrl = val?.value instanceof File ? URL.createObjectURL(val.value) : value?.base64_string;

                            return (
                                <div className='col-md-6 col-12 mb-1' key={val?.request_type_column_id || index}>
                                    <label className="form-label">
                                        {val?.request_type_column_name} {val?.is_required && "*"}
                                    </label>
                                    {val?.is_media ? (
                                        <div className="d-flex gap-1">
                                            <input
                                                type="file"
                                                multiple
                                                accept="image/*"
                                                onChange={(e) => dynamicInputHandle(e, val)}
                                                className=" w95"
                                            />
                                            {fileUrl && (
                                                <a href={fileUrl} target="_blank" rel="noreferrer">
                                                    <img className="rounded border" src={fileUrl} style={{ height: "30px", width: "30px", objectFit: "cover" }} alt="" />
                                                </a>
                                            )}
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            className="input-dd w100"
                                            onChange={(e) => dynamicInputHandle(e, val)}
                                            value={value?.request_type_column_value || ''}
                                        />
                                    )}
                                </div>
                            );
                        })}
                        <div className={isTicketEditable ? "col-12 mb-1" : "d-none"}>
                            <label className="form-label">Status</label>
                            <Dropdown
                                name="status"
                                options={statusOpts}
                                value={formValue?.status || null}
                                onChange={handleOnChange}
                                className="sk-input-dd w-100"
                                optionLabel="status_name"
                            />
                        </div>
                        <div className="col-12 mb-2">
                            <div className="row align-items-center">
                                <div className='col-md-6 col-12 d-flex align-items-center gap-3 mb-2'>
                                    <label className="mb-0">Require approval? </label>
                                    <input
                                        name="approval"
                                        checked={!!formValue?.approval}
                                        onChange={handleOnChange}
                                        className="sk-input-dd"
                                        type='checkbox'
                                    />
                                </div>
                                <div className="col-md-6 col-12 mb-2">
                                    {formValue?.approval && (
                                        <div>
                                            <label className="form-label">Project *</label>
                                            <Dropdown
                                                name="project"
                                                options={options?.projectOpt}
                                                value={formValue?.project}
                                                onChange={handleOnChange}
                                                className="sk-input-dd w-100"
                                                optionLabel="project_name"
                                                filter
                                                optionValue='project_id'
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {formValue?.approval && approverList?.length > 0 && (
                            <div className="col-12 mb-1">
                                <label className="form-label">Approve By *</label>
                                <div className="d-flex flex-wrap gap-3 my-1">
                                    {approverList.map((item) => item.user_code !== null && (
                                        <div key={item?.user_code} className="d-flex align-items-center gap-1">
                                            <input
                                                type="radio"
                                                id={`approver_${item?.user_code}`}
                                                name="approver_user_code"
                                                value={item?.user_code}
                                                onChange={handleOnChange}
                                                checked={parseInt(item?.user_code) === parseInt(formValue?.approver_user_code)}
                                            />
                                            <label htmlFor={`approver_${item?.user_code}`} className="mb-0">{item.user_display_name}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className="col-12 mb-1">
                            <label className="form-label">Summary *</label>
                            <div>
                                <textarea
                                    rows="2"
                                    className="w100 p-2"
                                    name='summary'
                                    value={formValue?.summary || ''}
                                    onChange={handleOnChange}
                                    disabled={isUserAuthorized}
                                />
                            </div>
                            <div>{calculateWordsFromString(formValue?.summary) <= 5 && calculateWordsFromString(formValue?.summary) + "/5 words"}</div>
                        </div>
                        <div className="col-12 mb-4">
                            <CommonImage
                                type="upload"
                                selectedImages={formValue?.files}
                                setSelectedImages={(e) => setFormValue((prev) => ({ ...prev, files: e, upsert: true }))}
                                disabled={isUserAuthorized}
                                is_paste={true}
                            />
                            <label className="text-muted mt-1 d-block" style={{ fontSize: '13px' }}>
                                Attachments (multiple allowed)
                            </label>
                        </div>
                        {isTicketEditable && (
                            <div className="col-12 mb-4">
                                <label className="form-label">Add Remark</label>
                                <input
                                    placeholder='Enter your Remark...'
                                    className='w100 input-dd'
                                    name="newComments"
                                    value={formValue?.newComments || ''}
                                    onChange={handleOnChange}
                                />
                            </div>
                        )}
                        <div className="col-12 d-flex gap-2 justify-content-end mt-2">
                            <button className="btn-default" type="button" onClick={handleCloseModal}>
                                Cancel
                            </button>
                            {loader ?
                                <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "65px" }}>
                                    <div className="spinner-border" role="status" style={{ width: "12px", height: "12px" }}>
                                        <span className="sr-only"></span>
                                    </div>
                                </button> :
                                <button
                                    className="btn-primary"
                                    type="button"
                                    onClick={(isTicketEditable && !formValue?.upsert) ? saveStatus : handleCreateTicket}
                                >
                                    Submit
                                </button>
                            }
                        </div>
                    </div>
                </form>
            </Dialog>
        </div>
    );
};

export default CreateTicket;